export default __webpack_public_path__ + "static/prescriptor-d9cb27490058ef7bfeb70cb30b74d125.png";